import React from 'react';
import { BsBell, BsBellFill, BsFileEarmarkText, BsGear } from 'react-icons/bs';

import { alertList as selectAlertList } from 'store/alert/alert.selector';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import * as selectAlert from 'store/alert/alert.selector';

import { updateAlert } from 'store/alert/alert.action';

import { alert } from 'lib/alert';
import { useToggle } from 'hooks/useToggle';

import { ModalAlertSettings } from './modal-alert-settings/modal-alert-settings.component';

import {
  NotificationContainer,
  NotificationDrowpdownContainer,
  AlertContainer,
  AlertHeader,
  AlertBody,
  SettingsContainer,
  NotificationHeader,
  NotificationBody,
  AlertTitle,
  AlertIcon,
  AlertEmpty,
  NotificationMenu,
} from './notification-dropdown.styles';

export const NotificationDropdown = () => {
  const dispatch = useAppDispatch();
  const [showNotifications, toggleNotifications] = useToggle();
  const [showSettings, toggleSettings] = useToggle();

  const alertList = useAppSelector(selectAlert.alertList);
  const alertError = useAppSelector(selectAlert.error);
  const alertAction = useAppSelector(selectAlert.action);
  const alertStatus = useAppSelector(selectAlert.status);

  React.useEffect(() => {
    if (alertAction === 'update') {
      if (alertStatus === 'failed' && alertError) {
        alert.error('Houve um erro ao remover o alerta! Tente novamente!');
      }
    }
  }, [alertAction]);

  const handleMakeRead = (alertId: string) => {
    dispatch(updateAlert({ alertId, isRead: true }));
  };

  return (
    <NotificationDrowpdownContainer>
      {/* Botão com nome acessível (out/2026 — era só o ícone clicável) */}
      <NotificationContainer
        as="button"
        type="button"
        className="bg-transparent"
        onClick={toggleNotifications}
        aria-label={
          alertList.length > 0
            ? `Alertas (${alertList.length} não lido${
                alertList.length > 1 ? 's' : ''
              })`
            : 'Alertas'
        }
        aria-expanded={showNotifications}
      >
        {alertList.length > 0 ? (
          <BsBellFill size={20} color="#fff" aria-hidden />
        ) : (
          <BsBell size={20} color="#fff" aria-hidden />
        )}
      </NotificationContainer>
      <NotificationMenu show={showNotifications}>
        <NotificationHeader>
          <h4>Alertas</h4>
          <SettingsContainer>
            <button
              type="button"
              onClick={toggleSettings}
              aria-label="Configurar alertas"
              title="Configurar alertas"
              style={{ background: 'none', border: 'none', padding: 0 }}
            >
              <BsGear size={16} color="#999" aria-hidden />
            </button>
          </SettingsContainer>
        </NotificationHeader>
        <NotificationBody>
          {alertList.length ? (
            alertList.map((x) => (
              <AlertContainer key={x.id}>
                <AlertHeader>
                  <AlertTitle>
                    <AlertIcon>
                      <BsFileEarmarkText size={14} color="#333" />
                    </AlertIcon>
                    <h4>{x.title}</h4>
                  </AlertTitle>
                  <>
                    <div className="time">10:00</div>
                    <div className="options">
                      <span onClick={() => handleMakeRead(x.id)}>
                        Marcar como lido
                      </span>
                    </div>
                  </>
                </AlertHeader>
                <AlertBody>{x.message}</AlertBody>
              </AlertContainer>
            ))
          ) : (
            <AlertEmpty>
              <h4>Parabéns, você leu todos os seus alertas!</h4>
            </AlertEmpty>
          )}
        </NotificationBody>
      </NotificationMenu>
      <ModalAlertSettings
        showModal={showSettings}
        setShowModal={toggleSettings}
      />
    </NotificationDrowpdownContainer>
  );
};
